import { React, useState, useContext, useEffect } from "react";
import SubHeader from "./SubHeader";
import { FormGroup, Col, Label, Input, Form, Row, NavLink, ListInlineItem, Dropdown, DropdownToggle, } from "reactstrap";
import projectPlaceholderImg from "../../assets/images/no-projects.png";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import { GlobalContext } from "../../App";
import axios from "../../api/axios";
import HoverTooltip from "../global/Tooltip";
import TopHeader from "./TopHeader";
import { BsChevronRight } from "react-icons/bs";
import { toast } from "react-toastify";
import { FaUndo } from "react-icons/fa";
import { InfinitySpin } from "react-loader-spinner";
import { useNavigate, useLocation } from "react-router-dom";

function ArchiveProjects() {
  const navigate = useNavigate();
  const currentDate = new Date().toISOString().substr(0, 10);
  const body = document.body;
  const mainPanel = document.querySelector(".main-panel");
  const maskBgOverlay = document.createElement("div");
  maskBgOverlay.id = "maskBgOverlay";
  maskBgOverlay.className = "maskBgOverlay";
  const location = useLocation();
  const { pathname } = location;
  const { rolexModuleData, user_id, serialSequence, roles,userProfile } = useContext(GlobalContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [modal, setModal] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [tempProjectList, setTempProjectList] = useState([]);
  const [milestoneUserList, setMilestoneUserList] = useState([]);
  const [taskUserList, setTaskUserList] = useState([]);
  const [filterProject, setFilterProject] = useState({
    projectId: "",
    projectTitle: "",
    projectStartDate: "",
    projectEndDate: "",
    createdBy: "",
  });
  const isSpecialAccess = rolexModuleData?.find( (data) => pathname === data?.description && data?.special === 1 )|| roles?.find((data1) => data1?.role_id === 1001) ? true : false;
  const [loading, setLoading] = useState(true); 
  // Handle Error
  const handleError = (error) => {
    setLoading(false);
    const statusCode = error.response ? error.response.status : null;
    let errorMessage = "An error occurred!";

    if (statusCode === 500) {
      errorMessage = "Internal Server Error!";
    } else if (statusCode === 404) {
      errorMessage = "Page Not Found!";
    }

    toast.error(errorMessage, {
      position: toast.POSITION.TOP_RIGHT,
      theme: "colored",
      autoClose: 2000,
    });
  };
  // ----------------------------------------------------------- Handle Close ---------------------------------------
  const handleClose = () => {
    setModal(false);
    setIsFilter(false);
    // body.style.overflow = "";
    // document.getElementById("maskBgOverlay").remove();
  };

  const toggleModal = () => {
    setIsFilter(false);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };

  const toggleFilter = () => {
    setIsFilter(true);
    setModal(!modal);
    body.style.overflow = "hidden";
    mainPanel.appendChild(maskBgOverlay);
  };
  // -------------------------------------------------------- Get User Data --------------------------------------
  const getUserData = () => {
    setLoading(true);
    const UserListCriteria  =  isSpecialAccess ? '' : userProfile || '';
    axios.get(`/getUserData?UserListCriteria=${JSON?.stringify(UserListCriteria)}`).then((response, error) => {
        const userList = response?.data?.[0]?.user_data?.filter( (item) => item?.user_id === user_id )?.[0]?.user_x_project;
        const temp = userList?.filter((data) => data?.project_access === 1)?.map((data) => data?.project_id);
        const milestoneUserList = response?.data?.[0]?.user_data?.filter((item) => item?.user_id === user_id)?.[0]?.user_x_milestone?.filter((data) => data?.milestone_access === 1)?.map((data) => data?.milestone_id);
        const taskUserList = response?.data?.[0]?.user_data?.filter((item) => item?.user_id === user_id)?.[0]?.user_x_task?.filter((data) => data?.task_access === 1)?.map((data) => data?.task_id);
        setMilestoneUserList(milestoneUserList);
        setTaskUserList(taskUserList);
        getArchiveProjectList(temp);
        setLoading(false);
      })
      .catch(handleError);
  };
  // ------------------------------------------------------- Add Project --------------------------------------------
  const updateProjectArchive = (e, project_id) => {
    const params = {
      user_id: user_id,
      updateId: project_id,
    };
    axios?.post("/updateProjectArchive", params)?.then((response) => {
          toast.success(`Project is Reopen successfully!`, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000,
          });
          handleClose();
          getUserData();
        }).catch(handleError);

  };

  // -------------------------------------------------------- Get Project List --------------------------------------
  const getArchiveProjectList = (projectList) => {
    setLoading(true);
    axios
      .get("/getArchiveProjectList")
      .then((response) => {
        const project = response?.data?.[0]?.project_data
          ?.sort((a, b) => (a.updatedDate < b.updatedDate ? 1 : -1))
          ?.filter((data) =>
          isSpecialAccess ||
            parseInt(data?.createdBy) === user_id
              ? data
              : projectList?.includes(data?.project_id)
          );
        setProjectList(project);
        setTempProjectList(project);
        setLoading(false);
      })
      .catch(handleError);

  };

  // -------------------------------------------------------- Filter Project List --------------------------------------
  const filtrerProjectList = (clear) => {
    const filterProjects = tempProjectList?.filter(
      (data) =>
        (data?.project_title?.includes(filterProject?.projectId) ||
          data?.project_code?.includes(filterProject?.projectId)) &&
        data?.start_date?.includes(filterProject?.projectStartDate) &&
        data?.end_date?.includes(filterProject?.projectEndDate) &&
        data?.created_user?.[0]?.name?.includes(filterProject?.createdBy)
    );
    setProjectList(filterProjects);
    if (clear) {
      handleClose();
    }
  };
  // ------------------------------------------------------- Clear Filter Field ------------------------------------------
  const ClearFilter = () => {
    setFilterProject({
      projectId: "",
      projectTitle: "",
      projectStartDate: "",
      projectEndDate: "",
      createdBy: "",
    });
    filtrerProjectList(false);
    setProjectList(tempProjectList);
  };

  // ---------------------------------------------------------- Mantain Log History ------------------------------
  const postLogHistory = () => {
    const param = {
      user_id: user_id,
      module_name: "Project Archive",
      operationPerformed: "navigate to project archive screen",
    };
    axios.post("/postLogHistory", param);
  };

  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {
    getUserData();
    // postLogHistory();
  }, []);
  return (
    loading ? (
      <div className="loader">
      <InfinitySpin width="200" color="#D81159" />
    </div>
    ) :
    (<>
      <TopHeader
        breadCrumb={
          <>
            <li className="nav-item">
              <a onClick={() => navigate("/home")} className="nav-link">
                Home <BsChevronRight />
              </a>
            </li>
            <li className="nav-item">
              <span>Projects Archive</span>
            </li>
          </>
        }
      />

      <SubHeader
        SubHeaderTitle="Status"
        ShowFilterIcon={true}
        openSidebar={modal}
        isFilter={isFilter}
        handleClose={handleClose}
        toggleModal={toggleModal}
        toggleFilter={toggleFilter}
        filterSubmit={filtrerProjectList}
        userStatus={
          <ListInlineItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
              <DropdownToggle className="activeuser" caret>
                Completed
              </DropdownToggle>
            </Dropdown>
          </ListInlineItem>
        }
        SlideBarContent={
          <Form className="modelform">
            <FormGroup>
              <Row>
                <Col md={12}>
                  <div className="resetFilterOption">
                    <a onClick={ClearFilter}>Clear Filter</a>
                  </div>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="projectTitle">Project ID/Title</Label>
                    <Input
                      type="text"
                      id="projectTitle"
                      name="projectTitle"
                      placeholder="Search By Project ID or Title"
                      value={filterProject?.projectId || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          projectId: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="startDate">Start Date</Label>
                    <Input
                      type="date"
                      id="startDate"
                      name="startDate"
                      value={filterProject?.projectStartDate || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          projectStartDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="endDate">End Date</Label>
                    <Input
                      type="date"
                      id="endDate"
                      name="endDate"
                      value={filterProject?.projectEndDate || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          projectEndDate: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label htmlFor="userRole">Created By</Label>
                    <Input
                      type="text"
                      id="createdBy"
                      name="createdBy"
                      value={filterProject?.createdBy || ""}
                      onChange={(e) =>
                        setFilterProject({
                          ...filterProject,
                          createdBy: e.target.value,
                        })
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>
            </FormGroup>
          </Form>
        }
      />
      <div id="projectManagement" className="">
        <div className="projectheader">
          {projectList?.length > 0 ? (
            <MDBTable align="middle" className="projectTable">
              <MDBTableHead>
                <tr>
                  <th scope="col" style={{ minWidth: "320px" }}>
                    {" "}
                    Project{" "}
                  </th>
                  <th scope="col">Status</th>
                  <th scope="col">Owner</th>
                  <th
                    scope="col"
                    style={{ minWidth: "220px", whiteSpace: "normal" }}
                  >
                    {" "}
                    Team Members{" "}
                  </th>
                  <th scope="col" className="text-center">
                    {" "}
                    Milestone{" "}
                  </th>
                  <th scope="col" className="text-center">
                    {" "}
                    Tasks{" "}
                  </th>
                  <th scope="col">Duration</th>
                  <th scope="col">Start Date</th>
                  <th scope="col">End Date</th>
                  {/* <th scope='col'>Project Document</th> */}
                  <th scope="col">Created On</th>
                  <th scope="col">Created By</th>
                  <th scope="col">Modified On</th>
                  <th scope="col">Modified By</th>
                  <th scope="col"> Action</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {projectList?.map((data) => (
                  <tr className="table-light">
                    <th scope="row">
                      {" "}
                      <span className="assignedId">
                        {" "}
                        {serialSequence?.[0]?.prefix}-{data?.project_code}{" "}
                      </span>{" "}
                      <NavLink a className="d-inline-block ps-2" onClick={() => navigate(`/milestones?param1=${btoa( data?.project_id )}&?param2=${btoa(data?.project_title)}`)} >
                        {" "}
                        {data?.project_title}{" "}
                      </NavLink>{" "}
                    </th>
                    <td>
                      {" "}
                      <div
                        className={
                          "badge " + (data?.project_status).replace(/\s/g, "")
                        }
                      >
                        {" "}
                        {data?.project_status}{" "}
                      </div>{" "}
                    </td>
                    <td>
                      {" "}
                      {(data?.project_owner && data?.project_owner?.[0]?.name) ||
                        " - "}
                    </td>
                    <HoverTooltip
                      arrow
                      title={
                        data?.project_x_owner?.length > 0
                          ? data?.project_x_owner
                              ?.map((data) => data?.user_data?.[0]?.name)
                              ?.join(", ")
                          : " - "
                      }
                    >
                      <td
                        style={{
                          minWidth: "220px",
                          maxWidth: "250px",
                          webkitLineClamp: "3",
                          webkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {" "}
                        {data?.project_x_owner?.length > 0
                          ? data?.project_x_owner
                              .map((data) => data?.user_data?.[0]?.name)
                              .join(", ")
                          : " - "}{" "}
                      </td>
                    </HoverTooltip>
                    <td>
                      <div className="progressBarWrap">
                        <div className="closedStatus">
                          {data?.milestone_master?.filter(
                            (data) =>
                              (isSpecialAccess
                                ? data
                                : milestoneUserList?.includes(
                                    data?.milestone_id
                                  )) &&
                              (data?.milestone_status === "Completed" ||
                                data?.milestone_status === "Cancelled")
                          )?.length || "0"}
                        </div>
                        <HoverTooltip
                          arrow
                          title={
                            <>
                              {Math.round(
                                (data?.milestone_master?.filter(
                                  (data) =>
                                    data?.milestone_status === "Completed" &&
                                    (isSpecialAccess
                                      ? data
                                      : milestoneUserList?.includes(
                                          data?.milestone_id
                                        ))
                                )?.length /
                                  data?.milestone_master?.filter((data) =>
                                  isSpecialAccess
                                      ? data
                                      : milestoneUserList?.includes(
                                          data?.milestone_id
                                        )
                                  )?.length) *
                                  100
                              ) || "0"}
                              % (
                              {data?.milestone_master?.filter(
                                (data) =>
                                  (isSpecialAccess
                                    ? data
                                    : milestoneUserList?.includes(
                                        data?.milestone_id
                                      )) &&
                                  data?.milestone_status === "Completed"
                              )?.length || "0"}{" "}
                              of{" "}
                              {data?.milestone_master?.filter((data) =>
                                isSpecialAccess
                                  ? data
                                  : milestoneUserList?.includes(
                                      data?.milestone_id
                                    )
                              )?.length || "0"}{" "}
                              Milestone Completed )
                            </>
                          }
                        >
                          <div className="progress" style={{ height: "15px" }}>
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{
                                width:
                                  data?.milestone_master?.filter((data) =>
                                  isSpecialAccess
                                      ? data
                                      : milestoneUserList?.includes(
                                          data?.milestone_id
                                        )
                                  )?.length > 0
                                    ? Math.round(
                                        (data?.milestone_master?.filter(
                                          (data) =>
                                            data?.milestone_status ===
                                              "Completed" &&
                                            (isSpecialAccess
                                              ? data
                                              : milestoneUserList?.includes(
                                                  data?.milestone_id
                                                ))
                                        )?.length /
                                          data?.milestone_master?.filter(
                                            (data) =>
                                            isSpecialAccess ? data
                                                : milestoneUserList?.includes(
                                                    data?.milestone_id
                                                  )
                                          )?.length) *
                                          100
                                      ) + "%"
                                    : "0%",
                              }}
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            >
                              &nbsp;
                            </div>
                            <div
                              className={`percentageText ${
                                Math.round(
                                  (data?.milestone_master?.filter(
                                    (data) =>
                                      data?.milestone_status === "Completed" &&
                                      (isSpecialAccess
                                        ? data
                                        : milestoneUserList?.includes(
                                            data?.milestone_id
                                          ))
                                  )?.length /
                                    data?.milestone_master?.filter((data) =>
                                    isSpecialAccess
                                        ? data
                                        : milestoneUserList?.includes(
                                            data?.milestone_id
                                          )
                                    )?.length) *
                                    100
                                ) > 50
                                  ? "text-white"
                                  : ""
                              }`}
                            >
                              {data?.milestone_master?.filter((data) =>
                              isSpecialAccess
                                  ? data
                                  : milestoneUserList?.includes(
                                      data?.milestone_id
                                    )
                              )?.length > 0
                                ? Math.round(
                                    (data?.milestone_master?.filter(
                                      (data) =>
                                        data?.milestone_status ===
                                          "Completed" &&
                                        (isSpecialAccess
                                          ? data
                                          : milestoneUserList?.includes(
                                              data?.milestone_id
                                            ))
                                    )?.length /
                                      data?.milestone_master?.filter((data) =>
                                      isSpecialAccess ? data
                                          : milestoneUserList?.includes(
                                              data?.milestone_id
                                            )
                                      )?.length) *
                                      100
                                  ) + "%"
                                : "0%"}
                            </div>
                          </div>
                        </HoverTooltip>

                        <div className="openStatus">
                          {data?.milestone_master?.filter(
                            (data) =>
                              (isSpecialAccess
                                ? data
                                : milestoneUserList?.includes(
                                    data?.milestone_id
                                  )) &&
                              !(data?.milestone_status === "Completed")
                          )?.length || "0"}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="progressBarWrap">
                        <div className="closedStatus">
                          {data?.task_master?.filter(
                            (data) =>
                              (isSpecialAccess
                                ? data
                                : taskUserList?.includes(data?.task_id)) &&
                              (data?.task_status === "Completed" ||
                                data?.task_status === "Cancelled")
                          )?.length || "0"}
                        </div>
                        <HoverTooltip
                          arrow
                          title={
                            <>
                              {Math.round(
                                (data?.task_master?.filter(
                                  (data) =>
                                    data?.task_status === "Completed" &&
                                    (isSpecialAccess
                                      ? data
                                      : taskUserList?.includes(data?.task_id))
                                )?.length /
                                  data?.task_master?.filter((data) =>
                                  isSpecialAccess
                                      ? data
                                      : taskUserList?.includes(data?.task_id)
                                  )?.length) *
                                  100
                              ) || "0"}
                              % (
                              {data?.task_master?.filter(
                                (data) =>
                                  (isSpecialAccess
                                    ? data
                                    : taskUserList?.includes(data?.task_id)) &&
                                  data?.task_status === "Completed"
                              )?.length || "0"}{" "}
                              of{" "}
                              {data?.task_master?.filter((data) =>
                                isSpecialAccess ? data
                                  : taskUserList?.includes(data?.task_id)
                              )?.length || "0"}{" "}
                              Task Completed )
                            </>
                          }
                        >
                          <div className="progress" style={{ height: "15px" }}>
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{
                                width:
                                  data?.task_master?.filter((data) =>
                                  isSpecialAccess
                                      ? data
                                      : taskUserList?.includes(data?.task_id)
                                  )?.length > 0
                                    ? Math.round(
                                        (data?.task_master?.filter(
                                          (data) =>
                                            data?.task_status === "Completed" &&
                                            (isSpecialAccess
                                              ? data
                                              : taskUserList?.includes(
                                                  data?.task_id
                                                ))
                                        )?.length /
                                          data?.task_master?.filter((data) =>
                                          isSpecialAccess ? data
                                              : taskUserList?.includes(
                                                  data?.task_id
                                                )
                                          )?.length) *
                                          100
                                      ) + "%"
                                    : "0%",
                              }}
                              aria-valuenow="25"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            >
                              &nbsp;
                            </div>
                            <div
                              className={`percentageText ${
                                Math.round(
                                  (data?.task_master?.filter(
                                    (data) =>
                                      data?.task_status === "Completed" &&
                                      (isSpecialAccess
                                        ? data
                                        : taskUserList?.includes(data?.task_id))
                                  )?.length /
                                    data?.task_master?.filter((data) =>
                                    isSpecialAccess ? data
                                        : taskUserList?.includes(data?.task_id)
                                    )?.length) *
                                    100
                                ) > 50
                                  ? "text-white"
                                  : ""
                              }`}
                            >
                              {data?.task_master?.filter((data) =>
                               isSpecialAccess
                                  ? data
                                  : taskUserList?.includes(data?.task_id)
                              )?.length > 0
                                ? Math.round(
                                    (data?.task_master?.filter(
                                      (data) =>
                                        data?.task_status === "Completed" &&
                                        (isSpecialAccess
                                          ? data
                                          : taskUserList?.includes(
                                              data?.task_id
                                            ))
                                    )?.length /
                                      data?.task_master?.filter((data) =>
                                      isSpecialAccess
                                          ? data
                                          : taskUserList?.includes(
                                              data?.task_id
                                            )
                                      )?.length) *
                                      100
                                  ) + "%"
                                : "0%"}
                            </div>
                          </div>
                        </HoverTooltip>
                        <div className="openStatus">
                          {data?.task_master?.filter(
                            (data) =>
                              (isSpecialAccess
                                ? data
                                : taskUserList?.includes(data?.task_id)) &&
                              !(data?.task_status === "Completed")
                          )?.length || "0"}
                        </div>
                      </div>
                    </td>
                    <td>
                      {data?.start_date?.length > 0
                        ? Math.floor(
                            (new Date(data?.end_date) -
                              new Date(data?.start_date)) /
                              (1000 * 60 * 60 * 24)
                          ) + 1 || " 0 "
                        : " 0 "}{" "}
                      days
                    </td>
                    <td>
                      {data?.start_date?.length > 0
                        ? new Date(data?.start_date).toLocaleDateString("en-TT")
                        : " - "}
                    </td>
                    <td
                      className={
                        data?.end_date < currentDate ? "dateExpired" : ""
                      }
                    >
                      {data?.end_date?.length > 0
                        ? new Date(data?.end_date).toLocaleDateString("en-TT")
                        : " - "}
                    </td>
                    {/* <td>{<NavLink className='downloadicon' href={global.SERVER_pathname + '/projectDoc/' + data?.project_document} target="_blank"> {data?.project_document} </NavLink> || '-'}</td> */}
                    <td>
                      {new Date(
                        data?.createdDate?.split(" ")?.[0]
                      ).toLocaleDateString("en-TT")}
                    </td>
                    <td>
                      {data?.created_user?.length > 0
                        ? data?.created_user?.[0]?.name
                        : "-"}
                    </td>
                    <td>
                      {new Date(
                        data?.updatedDate?.split(" ")?.[0]
                      ).toLocaleDateString("en-TT")}
                    </td>
                    <td>
                      {data?.updated_user?.length > 0
                        ? data?.updated_user?.[0]?.name
                        : "-"}
                    </td>
                    {rolexModuleData?.find(
                      (data) => pathname === data?.description && data?.update === 1
                    ) ||
                    roles?.find((data) => data?.role_id === 1001) ? (
                        <td onClick={(e)=>updateProjectArchive(e,data?.project_id)}><FaUndo/></td>
                    ) : <td>-</td>}
                
                  </tr>
                ))}
              </MDBTableBody>
            </MDBTable>
          ) : (
            <div className="defaultPlaceholder">
              <img src={projectPlaceholderImg} alt="No Project Archive" />
              <h4 className="defaultPlaceholderText">
                There are no Archive projects!
              </h4>
            </div>
          )}
        </div>
      </div>
    </>)
  );
}

export default ArchiveProjects;
